<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright pull-right">
        <a href="https://www.brasal.com.br/" target="_blank">
          <img src="/static/img/logo_brasal_c.png" alt="Brasal" class="logo_brasal">
        </a>        
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue